<div class="row filter-row">

  <div class="col-lg-12">
    <mat-form-field>
      <mat-label class="mat-label-class">BUSCAR VEÍCULO/PROPRIETÁRIO</mat-label>
      <input matInput [(ngModel)]="filter.searchQuery" (keydown.enter)="$event.target.blur(); false"
        (blur)="submitFilter()">
      <mat-icon matSuffix (click)="submitFilter()" class="cursor-pointer">search</mat-icon>
    </mat-form-field>
  </div>
  <div class="col-lg-12 mt-2">
    <label class="text-primary font-weight-bold">TIPO DE VEÍCULO</label>
    <div class="row pr-3 d-flex justify-content-between mt-2">
      <div class="col-4 col-md-4" *ngFor="let segment of allSegments">
        <div class="card text-center card-type-vehicle-filter"
          [ngClass]="{'selected': filter.segments && filter.segments.indexOf(segment.segment) >= 0}"
          (click)="changeSegment(segment.segment)">
          <i class="d-block mx-auto text-primary cursor-pointer" [ngClass]="segment.iconClass"></i>
          {{segment.segmentLabel}}
        </div>
      </div>
    </div>
  </div>

  <div class="col-lg-12 mt-2">
    <label class="text-primary font-weight-bold">STATUS</label>
    <mat-checkbox class="d-block" *ngFor="let status of statusOptions" [(ngModel)]="status.selected"
      (change)="updateStatus(status.option, $event)">
      {{status.option}}
    </mat-checkbox>
  </div>

  <div class="col-lg-12 mt-2">
    <mat-form-field>
      <mat-label>PERÍODO</mat-label>
      <input
        matInput
        type="text"
        name="daterangeInput"
        class="date-range input-text"
        ngxDaterangepickerBootstrap
        [(ngModel)]="selectedDateRange"
        [ranges]="ranges"
        [dateLimit]="365"
        [alwaysShowCalendars]="true"
        [showCustomRangeLabel]="false"
        [showCancel]="true"
        [showDropdowns]="true"
        [autoApply]="false"
        [linkedCalendars]="true"
        (datesUpdated)="selectedDate($event)"
      />
      @if (hasPeriodSelected) {
        <mat-icon
          matSuffix
          class="period-clear-icon"
          (click)="clearPeriodRange(); $event.stopPropagation()"
        >close</mat-icon>
      }
    </mat-form-field>
  </div>

  <div class="col-lg-12 mt-2">
    <mat-form-field>
      <mat-label>MARCAS</mat-label>
      <input type="text" matInput [formControl]="makeAutoCompleteControl" [matAutocomplete]="make" />
    </mat-form-field>

    <mat-autocomplete #make="matAutocomplete" [displayWith]="getMakeName" (optionSelected)="selectedMake($event)"
      autoActiveFirstOption>
      <mat-option *ngFor="let option of makeOptions | async" [value]="option">{{
        option.name
      }}</mat-option>
    </mat-autocomplete>
  </div>
  <div class="col-lg-12 selected-buttons-container" *ngIf="selectedMakes.length > 0">
    <button class="btn btn-sm btn-primary btn-rounded" *ngFor="let make of selectedMakes"
      (click)="removeSelectedMake(make)">
      {{ make.name }}
      <i class="material-icons icon-right">close</i>
    </button>
  </div>

  <div class="col-lg-12 mt-2">
    <mat-form-field>
      <mat-label>MODELOS</mat-label>
      <input type="text" matInput [formControl]="modelAutoCompleteControl" [matAutocomplete]="model" />
    </mat-form-field>

    <mat-autocomplete #model="matAutocomplete" [displayWith]="getModelName" (optionSelected)="selectedModel($event)"
      autoActiveFirstOption>
      <mat-option *ngFor="let option of modelOptions | async" [value]="option">{{ option.name }}</mat-option>
    </mat-autocomplete>
  </div>
  <div class="col-lg-12 selected-buttons-container" *ngIf="selectedModels.length > 0">
    <button class="btn btn-sm btn-primary btn-rounded" *ngFor="let model of selectedModels"
      (click)="removeSelectedModel(model)">
      {{ model.name }}
      <i class="material-icons icon-right">close</i>
    </button>
  </div>

  <div class="col-12 mt-2">
    <div class="row">
      <div class="col-12">
        <mat-form-field>
          <mat-label>CIDADE</mat-label>

          <input type="text" matInput [formControl]="cityControl" [matAutocomplete]="cityAutoComplete" />
          <mat-autocomplete #cityAutoComplete="matAutocomplete" (optionSelected)="selectCity($event.option.value)">
            <mat-option *ngFor="let option of cityOptions | async" [value]="option">
              {{ option.name }} - {{ option.uf }}
            </mat-option>
          </mat-autocomplete>
          <mat-icon matSuffix style="font-size: 16px; color: #16b097; cursor: pointer;" (click)="clearCity()"
            *ngIf="filter.cityId">close</mat-icon>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="col-lg-12 mt-2">
    <div class="row d-flex align-items-end">
      <div class="col-md-6">
        <mat-form-field>
          <mat-label>ANO</mat-label>
          <mat-select [(value)]="filter.modelYearStart" (selectionChange)="submitFilter()">
            <mat-option></mat-option>
            <mat-option *ngFor="let year of minYearOptions" [value]="year">
              {{ year }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field>
          <mat-select [(value)]="filter.modelYearEnd" (selectionChange)="submitFilter()">
            <mat-option></mat-option>
            <mat-option *ngFor="let year of maxYearOptions" [value]="year">
              {{ year }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="col-lg-12 mt-2">
    <div class="row">
      <div class="col-12">
        <label class="text-primary font-weight-bold">PREÇO</label>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <mat-form-field>
          <mat-label class="small-label">de</mat-label>
          <input matInput currencyMask [options]="{
              prefix: 'R$ ',
              thousands: '.',
              precision: 0,
              allowNegative: false
            }" [(ngModel)]="filter.priceStart" (keydown.enter)="$event.target.blur(); (false)"
            (blur)="submitFilter()" />
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field>
          <mat-label class="small-label">até</mat-label>
          <input matInput currencyMask [options]="{
              prefix: 'R$ ',
              thousands: '.',
              precision: 0,
              allowNegative: false
            }" [(ngModel)]="filter.priceEnd" (keydown.enter)="$event.target.blur(); (false)" (blur)="submitFilter()" />
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="col-lg-12 mt-2">
    <div class="row">
      <div class="col-12">
        <label class="text-primary font-weight-bold">KM</label>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <mat-form-field>
          <mat-label class="small-label">de</mat-label>
          <input matInput currencyMask [options]="{
              prefix: '',
              suffix: ' km',
              thousands: '.',
              precision: 0,
              allowNegative: false
            }" [(ngModel)]="filter.kmStart" (keydown.enter)="$event.target.blur(); (false)" (blur)="submitFilter()" />
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field>
          <mat-label class="small-label">até</mat-label>
          <input matInput currencyMask [options]="{
              prefix: '',
              suffix: ' km',
              thousands: '.',
              precision: 0,
              allowNegative: false
            }" [(ngModel)]="filter.kmEnd" (keydown.enter)="$event.target.blur(); (false)" (blur)="submitFilter()" />
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="col-lg-12 mt-2">
    <label class="text-primary font-weight-bold">DIFERENCIAIS</label>

    <mat-checkbox class="d-block" [(ngModel)]="filter.onlyWithExtraKey" (change)="submitFilter()">
      Com chave reserva
    </mat-checkbox>
    <mat-checkbox class="d-block" [(ngModel)]="filter.onlyWithCarManual" (change)="submitFilter()">
      Com manual do proprietário
    </mat-checkbox>
  </div>
  <div class="col-lg-12 mt-2">
    <label class="text-primary font-weight-bold">MOTIVO</label>
    <mat-checkbox class="d-block" *ngFor="let reason of reasonOptions" [(ngModel)]="reason.selected"
      (change)="updateReason(reason.option, $event)">
      {{reason.option}}
    </mat-checkbox>
  </div>
  <div class="col-lg-12 mt-2">
    <label class="text-primary font-weight-bold">MOTIVO PARA ARQUIVAMENTO</label>
    <mat-checkbox class="d-block" *ngFor="let reason of reasonArchiveOptions" [(ngModel)]="reason.selected"
      (change)="updateReasonArchive(reason.option, $event)">
      {{reason.option}}
    </mat-checkbox>
  </div>
</div>